import { Card, Divider, Typography } from "@mui/material";
import { Box, Rating, Stack } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { tokens } from "../../../../store/tokens";

const RatingPill = ({ rating }) => (
  <Stack
    direction={"row"}
    alignItems={"center"}
    sx={{
      px: 1.25,
      py: 0.25,
      borderRadius: `${tokens.radius.sm}px`,
      bgcolor: tokens.color.successBg,
    }}
  >
    <Typography variant="caption" sx={{ color: tokens.color.success, fontWeight: 700 }}>
      {rating}
    </Typography>
  </Stack>
);

const ReviewRow = ({
  avatar,
  name,
  rating,
  datetime,
  text,
  onAvatarClick,
  avatarSize = 60,
}) => (
  <Stack spacing={2} direction={"row"} alignItems={"flex-start"}>
    <Box
      component="img"
      sx={{
        width: avatarSize,
        height: avatarSize,
        objectFit: "cover",
        cursor: "pointer",
        borderRadius: "50%",
        flexShrink: 0,
      }}
      alt={name ?? "Reviewer"}
      src={avatar}
      onClick={onAvatarClick}
    />
    <Stack spacing={0.5} sx={{ minWidth: 0 }}>
      <Typography variant="subtitle1" sx={{ color: tokens.color.ink }}>
        {name}
      </Typography>
      <Stack spacing={1} direction={"row"} alignItems={"center"}>
        <Rating name="read-only" value={parseFloat(rating)} readOnly size="small" />
        <RatingPill rating={rating} />
        <Divider orientation="vertical" flexItem sx={{ borderColor: tokens.color.line }} />
        <Typography variant="caption" sx={{ color: tokens.color.inkFaint }}>
          {datetime}
        </Typography>
      </Stack>
      <Typography variant="body2" sx={{ color: tokens.color.inkMuted }}>
        {text}
      </Typography>
    </Stack>
  </Stack>
);

const Reviewer = (props) => {
  const navigate = useNavigate();
  const { fetchedReviewItem, fetchedReviewList } = props;
  const { datetime, id, rating, type, user_name, user_pic, user_review, poster } =
    fetchedReviewItem;

  // Replies to this review share its id via `refer`.
  const replies = fetchedReviewList?.filter((element) => element.refer == id) ?? [];

  return (
    <Card
      elevation={0}
      sx={{
        padding: `${tokens.card.padding.md}px`,
        borderRadius: `${tokens.card.radius}px`,
        border: `1px solid ${tokens.color.line}`,
      }}
    >
      {type !== "replay" && (
        <ReviewRow
          avatar={user_pic}
          name={user_name}
          rating={rating}
          datetime={datetime}
          text={user_review}
          onAvatarClick={() => navigate("/profiledetails/" + poster)}
        />
      )}

      {replies
        .filter((element) => element?.type === "replay")
        .map((element) => (
          <Box key={element.id} sx={{ pl: { xs: 4, sm: 8 }, mt: 2 }}>
            <ReviewRow
              avatar={element?.user_pic}
              name={element?.user_name}
              rating={element?.rating}
              datetime={element?.datetime}
              text={element?.user_review}
              onAvatarClick={() => navigate("/profiledetails/" + element?.poster)}
              avatarSize={40}
            />
          </Box>
        ))}
    </Card>
  );
};

export default Reviewer;
